.itemSubWrapper {
    display: flex;
    align-items: center;
    border-radius: var(--ng-rd-6);
    overflow: hidden;
    padding: 0px var(--ng-gp-8);
    gap: var(--ng-gp-8);
    height: 100%;
}
